import React from 'react';
import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { FormValues } from '../../types';
import { getCustomizerLocaleOnChange } from '../../utils';
import * as ShopSelectors from 'selectors/ShopSelectors';
import { useTranslation } from 'services/localization';

export interface Props {
	sectionIndex: number;
	contentIndex: number;
}
const TextContentHeading = (props: Props) => {
	const { sectionIndex, contentIndex } = props;
	const defaultLanguage = useSelector(ShopSelectors.activeShopDefaultLanguage);
	const { t } = useTranslation();
	const { control } = useFormContext<FormValues>();
	return (
		<Controller
			name={`onlineLayout.about.customContent.sections.${sectionIndex}.content.${contentIndex}.heading`}
			control={control}
			render={({ field }) => (
				<TextField
					value={field.value?.def}
					placeholder={t('common:form.heading', 'Heading')}
					fullWidth
					label={t('common:form.heading', 'Heading')}
					onChange={(e) =>
						field.onChange(
							getCustomizerLocaleOnChange(e.target.value, field.value, defaultLanguage),
						)
					}
				/>
			)}
		/>
	);
};

export default TextContentHeading;
